import { BreaksMappingDestination } from 'app/constants/configuration/breaksMappingDestination'

export const getBreaksMappingDestinationName = (
  breaksMappingDestination: BreaksMappingDestination,
  translate: (string) => string,
): string => {
  const text: string = BreaksMappingDestination[breaksMappingDestination]
  return translate(`breaksMappingDestination.${text}`)
}
